"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
/**
 * Custom hook to handle React element props manipulation and defaults
 * @param {React.ReactElement|any} element - The element to potentially clone
 * @param {Object} propsOverrides - Props to override/merge with existing props
 * @returns {React.ReactElement|any} - The processed element
 */
const useElementProps = (element, propsOverrides = {}) => {
  return (0, _react.useMemo)(() => {
    if (/*#__PURE__*/(0, _react.isValidElement)(element)) {
      return /*#__PURE__*/(0, _react.cloneElement)(element, {
        ...element.props,
        ...propsOverrides
      });
    }
    return element;
  }, [element, propsOverrides]);
};
var _default = exports.default = useElementProps;